let howitworksCarousel = $('#howitworks_carousel');

if (howitworksCarousel.length > 0) {
    howitworksCarousel.slick({
        infinite: false,
        touchThreshold: 100,
        speed: 300,
        slidesToShow: 1,
        centerMode: true,
        nextArrow: '<button class="slick-next"><i class="fas fa-chevron-right"></i></button>',
        prevArrow: '<button class="slick-prev"><i class="fas fa-chevron-left"></i></button>',
    });
}
